/**
 * @enum {string}
 */
export default {
  /**
   * @type {string}
   */
  ANGLE: 'a',
  /**
   * @type {string}
   */
  COLOR: 'c',
  /**
   * @type {string}
   */
  IS_CIRCLE: 'l',
  /**
   * @type {string}
   */
  IS_RECTANGLE: 'r',
  /**
   * @type {string}
   */
  IS_TEXT: 't',
  /**
   * @type {string}
   */
  NAME: 'n',
  /**
   * @type {string}
   */
  SHOW_LABEL: 'b',
  /**
   * @type {string}
   */
  OPACITY: 'o',
  /**
   * @type {string}
   */
  AZIMUT: 'z',
  /**
   * @type {string}
   */
  SHOW_MEASURE: 'm',
  /**
   * @type {string}
   */
  SIZE: 's',
  /**
   * @type {string}
   */
  STROKE: 'k'
};
